/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/homepage/flip-cards.js":
/*!*****************************************************!*\
  !*** ./zrc/scripts/sections/homepage/flip-cards.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n\nclass FlipCards extends window.HTMLElement {\n  connectedCallback() {\n    this.$section = this;\n    this.configSlider();\n  }\n  configSlider() {\n    let swiper = null;\n    const $sliderContainer = this.$section.querySelector(\".flip-cards-items\");\n    const totalItems = JSON.parse($sliderContainer.dataset.items);\n    const $prevEl = $sliderContainer.parentNode.querySelector(`.flip-cards-arrow-prev`);\n    const $nextEl = $sliderContainer.parentNode.querySelector(`.flip-cards-arrow-next`);\n    const swiperSettings = {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_0__.Navigation],\n      init: false,\n      loop: totalItems > 5,\n      speed: 200,\n      slidesPerView: \"auto\",\n      centerInsufficientSlides: !(totalItems > 5),\n      centeredSlides: totalItems > 5,\n      longSwipesRatio: 0.01,\n      navigation: {\n        prevEl: $prevEl,\n        nextEl: $nextEl\n      },\n      breakpoints: {\n        1: {\n          spaceBetween: 19\n        },\n        700: {\n          spaceBetween: 25\n        }\n      },\n      on: {\n        beforeDestroy: () => {\n          $prevEl.classList.remove(\"swiper-button-lock\");\n          $prevEl.removeAttribute(\"disabled\");\n          $nextEl.classList.remove(\"swiper-button-lock\");\n          $nextEl.removeAttribute(\"disabled\");\n        }\n      }\n    };\n    const setSlider = function () {\n      let loop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;\n      if (swiper !== null) {\n        swiper.destroy();\n      }\n      swiperSettings.loop = loop;\n      swiperSettings.centerInsufficientSlides = !loop;\n      swiperSettings.centeredSlides = loop;\n      swiper = new swiper__WEBPACK_IMPORTED_MODULE_0__.default($sliderContainer, swiperSettings);\n      swiper.init();\n    };\n    window.responsiveScripts({\n      defaultCallback: () => {\n        setSlider(totalItems > 5);\n      },\n      responsive: {\n        1262: () => {\n          setSlider(totalItems > 4);\n        },\n        1014: () => {\n          setSlider(totalItems > 3);\n        },\n        764: () => {\n          setSlider(totalItems > 2);\n        },\n        418: () => {\n          setSlider(totalItems > 1);\n        }\n      }\n    });\n  }\n}\nwindow.customElements.define(\"flip-cards\", FlipCards);//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///./zrc/scripts/sections/homepage/flip-cards.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"flip-cards": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/homepage/flip-cards.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkgetmore_workflow"] = globalThis["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;